export const ParamantraFeatures = [
    { name: "Custom Fields", type: "No" },
    { name: "Full Call Centre Software", type: "No" },
    { name: "Integrated WhatsApp For Business Support (with full Automation like MakeMyTrip)*", type: "No" },
    { name: "Workflow Management - Automate lead & sales management", type: "Yes" },
    { name: "Booking Form with Support for Agreement + Brokerage Calculations", type: "Yes" },
    { name: "Insta Connect - For Instant Auto connected Call back to Customers", type: "Yes" },
    { name: "Create & Track Price Quotes", type: "Yes" },
    { name: "Schemes & Discounts", type: "No" },
    { name: "Connected Facebook Adverts Tracking - Auto CPL calculations & Dashboards", type: "No" },
    { name: "Drip Marketing", type: "No" },
    { name: "Inventory management - projects, towers, configurations and units", type: "Yes" },
    { name: "Customer Access & Online Interface", type: "No" },
    { name: "Online Bookings, Schemes & Discounts", type: "No" },
    { name: "ISO 27001 Certified Data Security & Compliance", type: "No" }
];
export default ParamantraFeatures;
